import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AppBarCMS } from '../../../../basic/index.jsx';
import { CollapseBlock, Spinner } from '../../../../common/index.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import { useToastMessages } from '../../../../../hooks/useToastMessages.jsx';
import useIsUserAdmin from '../../../../../hooks/useIsUserAdmin.jsx';
import checkPermission from '../../../../../utils/helpers/checkPermission.jsx';
import {
  useGetBugReportsQuery,
  useSetBugReportResolvedMutation,
} from '../../../../../redux/services/bug_reports.jsx';
import BugReportsTable from './BugReportsTable.jsx';
import BugReportDetailModal from './BugReportDetailModal.jsx';

const BugReportsPage = () => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user);
  const isAdmin = useIsUserAdmin();
  const { successMessage, apiErrorMessage } = useToastMessages();
  const [previewId, setPreviewId] = useState(null);

  const { data: bugReports, isLoading } = useGetBugReportsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [setBugReportResolved] = useSetBugReportResolvedMutation();

  const canResolve = checkPermission(user, 'bug-reports.update', isAdmin);

  useEffect(() => {
    document.title = t('Nahlásené chyby') + ' - FRI CMS';
  }, [t]);

  const handleSetResolved = async (id, isResolved) => {
    try {
      await setBugReportResolved({ id, isResolved }).unwrap();
      successMessage({
        message: isResolved
          ? t('Chyba bola označená ako vyriešená.')
          : t('Chyba bola označená ako nevyriešená.'),
      });
    } catch (error) {
      apiErrorMessage(error);
    }
  };

  return (
    <>
      <AppBarCMS
        title={t('Nahlásené chyby')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
      />

      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          {isLoading ? (
            <Spinner />
          ) : (
            <BugReportsTable
              bugReports={bugReports}
              onPreview={setPreviewId}
              onSetResolved={handleSetResolved}
              canResolve={canResolve}
            />
          )}
        </CollapseBlock>
      </div>

      <BugReportDetailModal
        bugReportId={previewId}
        onClose={() => setPreviewId(null)}
        onSetResolved={handleSetResolved}
        canResolve={canResolve}
      />
    </>
  );
};

export default BugReportsPage;
